module.exports = __webpack_public_path__ + "img/tczf_summary_Image.33f86933.png";